var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 16,
    viewBox: "0 0 21 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2882 15.3063L7.22605 15.2304C5.91081 15.204 4.59228 15.2568 3.30283 14.9827C1.34126 14.5732 1.2023 12.5653 1.05689 10.881C0.856523 8.51319 0.934089 6.10238 1.3122 3.7543C1.52565 2.43679 2.36569 1.65061 3.66477 1.56506C8.05012 1.25459 12.4646 1.29138 16.8403 1.43623C17.3024 1.44951 17.7677 1.52209 18.2234 1.6047C20.4727 2.00761 20.5275 4.28301 20.6733 6.19847C20.8187 8.13369 20.7573 10.0788 20.4794 12.0009C20.2564 13.5923 19.8298 14.9268 18.0294 15.0557C15.7737 15.2241 13.5697 15.3598 11.3076 15.3166C11.3077 15.3063 11.2947 15.3063 11.2882 15.3063ZM8.90007 11.2774C10.6 10.28 12.2674 9.29916 13.9576 8.30844C12.2545 7.31103 10.5903 6.33024 8.90007 5.33952V11.2774Z",
    fill: "#FCFCFC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.5d9a4e23ced7a463ba93cfa7bfd6defa.svg";
export { ForwardRef as ReactComponent };